import React, { memo, useCallback } from 'react';

import { useSelector } from 'react-redux';

import { useFeatures } from '@atc/features';

import { Alert, Box, Button, Glyphicon, SubHeading } from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import { psxSellYourCarLinkClick } from 'reaxl-analytics-handlers';

import paymentsDuck from '@/ducks/paymentsDuck.js';
import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

function PsxSellYourCarBoxContainer() {
    const { id: listingId, pricingDetail: { salePrice: price } = {} } = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory) || {};
    const paymentsInfo = useSelector(paymentsDuck.selectors.getPaymentsInfo);
    const { offerPrice } = useSelector(paymentsDuck.selectors.getPencilingValues) || {};

    const {
        brand: [, { brand_name: brandName }],
        psx_config: [, { sycLink }],
    } = useFeatures([
        'brand',
        'psx_config',
    ]);

    const handleSellYourCarCTAClick = useCallback((event) => {
        sendClick(psxSellYourCarLinkClick, event, {
            listingId,
            walletData: {
                paymentsInfo: paymentsInfo || {},
                price,
                offerPrice,
            },
        });
    }, [listingId, paymentsInfo, price, offerPrice]);

    return (
        <Box
            borderColor="neutral-secondary"
            backgroundColor="neutral-primary"
            className="margin-bottom-4 margin-bottom-sm-0"
        >
            <SubHeading
                size={400}
                className="margin-bottom-2"
            >
                List Your Car on
                {' '}
                {brandName}
            </SubHeading>
            <p>This car is being sold by a private seller, so instead of a trade-in value, you can sell your car on Private Seller Exchange.</p>
            <Alert bsStyle="info">
                On average, sellers receive 28% more for their vehicle by listing on Private Seller Exchange compared to trade-in.
            </Alert>
            <Button
                block
                bsStyle="secondary"
                onClick={handleSellYourCarCTAClick}
                href={sycLink}
                target="_blank"
            >
                List My Car&nbsp;
                <Glyphicon glyph="offsite" />
            </Button>
        </Box>
    );
}

export default memo(PsxSellYourCarBoxContainer);
